import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BulkRequestModalLoader from "../bulk-request-modal-loader";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApplicantSelect from "@Broker/@Modules/util-components/application/applicant-select.vue";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RequestDocumentsStep",
  components: {
    BulkRequestModalLoader,
    ApplicantSelect,
    MaterialInput
  },
  mixins: [validationMixin],
  props: {
    documentsClassifications: {
      type: Array,
      required: true
    },
    selectedClassifications: {
      type: Array,
      required: true
    },
    selectedApplicants: {
      type: Object,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  validations: {
    selectedClassifications: {
      required,
      minLength: minLength(1)
    }
  },
  computed: {
    isValid() {
      return this.documentsClassifications.length && !this.$v.$invalid && this.hasSelectedApplicants;
    },
    redirectToDocumentsLink() {
      var _this$$router$query;
      //if already in documents just stay here and avoid duplicate navigation
      if (((_this$$router$query = this.$router.query) == null ? void 0 : _this$$router$query.tab) === "documents") return {};

      //if not lets go to documents
      return {
        name: "application-documents",
        query: {
          tab: "documents"
        }
      };
    },
    allDocumentsMarked: {
      get() {
        return this.documentsClassifications.length === this.selectedClassifications.length;
      },
      set(value) {
        this.$emit("select-all-document-requests", value);
      }
    },
    table() {
      return {
        columns: ["selected", "classification", "description", "applicants"],
        options: {
          filterable: false,
          sortable: [],
          headings: {
            selected: this.$t("global.words.selected"),
            classification: this.$t("global.words.classification"),
            description: this.$t("global.words.description"),
            applicants: this.$t("documents.requestFromWhom")
          },
          perPage: 999999,
          tabbable: false,
          skin: "table mb-0",
          columnsClasses: {
            selected: "w-10 text-center",
            classification: "w-30",
            description: "w-30",
            applicants: "w-30"
          },
          texts: {
            noResults: this.$t("request-package.requestDocuments.emptyDocumentsClassification.full")
          }
        }
      };
    },
    hasSelectedApplicants() {
      return this.selectedClassifications.every(documentRequestId => {
        var _this$selectedApplica;
        return ((_this$selectedApplica = this.selectedApplicants[documentRequestId]) == null ? void 0 : _this$selectedApplica.length) > 0;
      });
    }
  },
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    },
    allDocumentsMarked(value) {
      if (this.$refs.selectAll) this.$refs.selectAll.checked = value;
    }
  },
  methods: {
    handleSelectClassification(documentClassification) {
      this.$emit("select-document-request", documentClassification);
    },
    classificationIsSelected(documentRequest) {
      var _context;
      return _includesInstanceProperty(_context = this.selectedClassifications).call(_context, documentRequest);
    },
    handleRedirectClick() {
      var _this$$router$query2;
      this.$emit("hide-modal");
      if (((_this$$router$query2 = this.$router.query) == null ? void 0 : _this$$router$query2.tab) === "documents") return;

      //if not lets go to documents
      this.$router.replace({
        name: "application-documents",
        query: {
          tab: "documents"
        }
      });
    },
    handleSelectAllClassifications() {
      this.$emit("select-all-document-requests", !this.allDocumentsMarked);
    },
    handleChangeSelectedApplicants(applicants, documentRequestId) {
      this.$emit("change-selected-coapplicants", _objectSpread(_objectSpread({}, this.selectedApplicants), {}, {
        [documentRequestId]: applicants
      }));
    }
  }
});